import Feature4 from './Feature4'
export default Feature4
